/**
 * 内容处理模块初始化
 * 提供注册内容处理器的便捷方法
 *
 * 核心功能：
 * 1. 自动注册所有内容处理器
 * 2. 确保内容处理器正确配置
 * 3. 提供简化的应用初始化接口
 */
import { ContentProcessorService } from './services/content-processor.service.js';
import { TextProcessor } from './text/TextProcessor.js';
import { PdfContentProcessor } from './pdf/PdfContentProcessor.js';
import { ContentType } from '@readsavor/types';
import { LoggerService } from '../logging/services/logger.service.js';
/**
 * 注册内容处理器
 * 注册所有内容处理器到内容处理服务
 *
 * 应在应用启动时调用
 */
export function registerContentProcessors() {
    const logger = LoggerService.getInstance();
    try {
        // 获取内容处理服务实例
        const contentProcessor = ContentProcessorService.getInstance();
        // 注册文本处理器
        contentProcessor.registerProcessor(ContentType.TEXT, new TextProcessor());
        // 注册PDF处理器
        contentProcessor.registerProcessor(ContentType.PDF, new PdfContentProcessor());
    }
    catch (error) {
        logger.error('[Content] Failed to register content processors', { error });
        throw new Error('Failed to register content processors: ' +
            (error instanceof Error ? error.message : String(error)));
    }
}
/**
 * 默认导出注册函数
 */
export default registerContentProcessors;
//# sourceMappingURL=initialize.js.map